import { render, staticRenderFns } from "./Reservierung.vue?vue&type=template&id=0a03e892"
import script from "./Reservierung.vue?vue&type=script&lang=ts"
export * from "./Reservierung.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports